module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "px3 py4"
  }, [_c('h1', {
    staticClass: "center m0 mb3",
    domProps: {
      "innerHTML": _vm._s(_vm.content.title)
    }
  }), _vm._v(" "), (_vm.content.description) ? _c('div', {
    staticClass: "flex flex-wrap justify-center"
  }, [_c('p', {
    staticClass: "col-7",
    domProps: {
      "innerHTML": _vm._s(_vm.content.description)
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative",
      "height": "0",
      "padding-bottom": "56.25%"
    }
  }, [_c('iframe', {
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%",
      "left": "0"
    },
    attrs: {
      "src": "https://www.youtube.com/embed/75KGIq7SToU?rel=0?ecver=2",
      "width": "640",
      "height": "360",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-994bb002","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Film.vue
// module id = 130
// module chunks = 0